import { ArrowDownThin } from '@ori-ui/icons';
import type { AccordionProps } from '@ori-ui/mui';
import { Accordion as MuiAccordion, AccordionDetails, AccordionSummary, Typography, styled } from '@ori-ui/mui';
import React, { useState } from 'react';

const StyledMuiAccordion = styled(MuiAccordion)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  '&::before': {
    display: 'none',
  },
  '& .Mui-expanded': {
    margin: '0 !important',
  },
}));

const StyledAccordionSummary = styled(AccordionSummary)(() => ({
  border: 'none',
  minHeight: '48px !important',
  '& .MuiAccordionSummary-content': {
    margin: '0 !important',
  },
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  fontSize: theme.typography.fontSize,
}));

interface Props extends AccordionProps {
  header?: string;
}

export const Accordion: React.FC<Props> = ({ children, header, ...rest }) => {
  const [expanded, setExpanded] = useState<boolean>(false);

  function handleChange(isExpanded: boolean) {
    return () => setExpanded(isExpanded);
  }

  return (
    <StyledMuiAccordion
      expanded={expanded}
      elevation={0}
      onChange={handleChange(!expanded)}
      {...rest}
    >
      <StyledAccordionSummary expandIcon={<ArrowDownThin />}>
        <StyledTypography variant="body2">{header}</StyledTypography>
      </StyledAccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledMuiAccordion>
  );
};
